import { Box, Button, Card, Grid, IconButton, InputBase, Typography, useMediaQuery } from '@mui/material'
import React, { useEffect, useState } from 'react'
import SearchIcon from '@mui/icons-material/Search';
import { apiList, config, InvokeApi } from '../../../services/ApiServices';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { useNavigate, useNavigation } from 'react-router-dom';

const Blogs = () => {
    const isMobile = useMediaQuery("(max-width: 768px)");
    const theme_color = '#0169b0';
    const navigate = useNavigate();
    const [searchResult, setSearchResult] = useState("");
    const handleSearch = (e) => {
        setSearchResult(e.target.value);
    }
    const [blogData, setBlogsData] = useState([]);
    const [page, setPage] = useState(1);
    const itemsPerPage = 12;
    const start = (page - 1) * itemsPerPage;
    const end = start + itemsPerPage;
    const searchBy = searchResult ? blogData.filter((item) => item.blogTitle.toLowerCase().includes(searchResult.toLowerCase())) : blogData;
    const totalPages = Math.ceil(blogData.length / itemsPerPage)
    const [on_load, setOnLoad] = useState(0);
    const [error, setError] = useState(null);

    const handleNavigate = (ogUrl) => {
        navigate(ogUrl);
        window.scrollTo({ top: 0, behavior: "smooth" });
    }

    const PageItem = ({ p, page, setPage, theme_color }) => (
        <Box
            onClick={() => setPage(p)}
            sx={{
                borderRadius: 2,
                backgroundColor: p === page ? theme_color : 'transparent',
                px: 2,
                py: 1,
                cursor: 'pointer',
                textAlign: 'center',
            }}
        >
            <Typography sx={{ color: p === page ? 'white' : 'black', fontSize: 16 }}>
                {p}
            </Typography>
        </Box>
    );

    useEffect(() => {
        const loadData = async () => {
            try {
                setError(null);

                const response = await InvokeApi( config.podarJuniors + apiList.getArticles, { });

                if (response?.status === 200) {
                    setBlogsData(response.data.articles);
                    setOnLoad(1);
                } else {
                    setBlogsData([]);
                }
            } catch (error) {
                console.log('Error loading data:', error);
                setError('Failed to load articles. Please try again.');
                setBlogsData([]);
            } finally {

            }
        }
        loadData();
    }, [on_load]);

    return (
        <>
            <Grid>
                <Grid>
                    <Grid container sx={{ alignItems: 'center', justifyContents: 'center', flexDirection: 'column', alignContent: 'center', }}>
                        <Typography variant="h3" sx={{ color: theme_color, fontWeight: 'bold', my: isMobile ? 1 : 2, mt: 10 }}>Blogs</Typography>
                        <Typography variant='h6' sx={{ textAlign: 'center', mx: isMobile ? 1 : 15 }}>Podar Juniors has a vast database, it helps users to search based on various criteria such as location, courses offered, institution name, and more. Users can access detailed information about various courses available across different colleges, including curriculum, duration, fee structure, and scholarship offered.</Typography>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                width: isMobile ? "90%" : '60%',
                                maxWidth: 450,
                                borderRadius: 2,
                                overflow: "hidden",
                                border: "2px solid #2b5d89",
                                m: isMobile ? 1 : 5
                            }}
                        >
                            <InputBase
                                placeholder="Search Blog Title"
                                value={searchResult}
                                onChange={handleSearch}
                                sx={{
                                    flex: 2,
                                    px: 2,
                                }}
                            />
                            <IconButton
                                sx={{
                                    backgroundColor: "#2b5d89",
                                    borderRadius: 0,
                                    color: "white",
                                    ":hover": {
                                        color: "white",
                                        backgroundColor: "#2b5d89",
                                    }
                                }}>
                                <SearchIcon />
                            </IconButton>
                        </Box>
                    </Grid>
                    <Grid container spacing={6} sx={{ px: isMobile ? 1 : 10, py: isMobile ? 1 : 2, alignItems: 'center', justifyContent: 'center' }}>
                        {searchBy?.length > 0 ?
                            (searchBy.slice(start, end).map((item, index) => (
                                <Grid item xs={12} sm={12} md={3} lg={3}>
                                    <Card sx={{ cursor: 'pointer', overflow: 'hidden' }} onClick={() => { handleNavigate(`/article/${item.ogUrl}`) }}>
                                        <Box sx={{ position: 'relative', transition: 'transform 0.5s ease', ':hover':{transform: 'scale(1.02)'} }}>
                                            <img src={item.featuredUrl} style={{ width: isMobile ? '100%' : 350, height: 'auto', objectFit: 'cover', display: 'block', }} />
                                            <Card sx={{ position: 'absolute', bottom: 7, right: -3, backgroundColor: 'white', borderTopLeftRadius: 10, borderBottomLeftRadius: 10, p: 1, border: `1.5px solid ${theme_color}` }}>
                                                <Typography sx={{ color: theme_color, fontWeight: 'bold', fontSize: 12 }}>{item.category}</Typography>
                                            </Card>
                                        </Box>
                                        <Box sx={{ p: isMobile ? 1 : 2 }}>
                                            <Box sx={{ width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start' }}>
                                                <Typography sx={{ color: theme_color, fontWeight: '600', fontSize: 14 }}>Updated On:</Typography>
                                                <Typography sx={{ color: 'grey', fontWeight: '500', ml: 1, fontSize: 12 }}>{item.date}</Typography>
                                            </Box>
                                            <Box>
                                                <Typography
                                                    sx={{
                                                        display: '-webkit-box',
                                                        WebkitLineClamp: 2,
                                                        WebkitBoxOrient: 'vertical',
                                                        overflow: 'hidden',
                                                        color: theme_color,
                                                        fontWeight: 'bold',
                                                        my: 1,
                                                        ":hover": {
                                                            textDecorationLine: 'underline'
                                                        }
                                                    }}
                                                >
                                                    {item.blogTitle}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Card>
                                </Grid>
                            ))) : (
                                <Grid container sx={{ width: '100%', alignItems: 'center', justifyContent: 'center', m: 10 }}>
                                    <Typography>No Data Found</Typography>
                                </Grid>
                            )}
                    </Grid>
                    <Grid sx={{ px: isMobile ? 1 : 10 }}>
                        {searchBy.length > itemsPerPage && (
                            <Grid
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'center',
                                    my: 6,
                                    alignItems: 'center',
                                    gap: 1,
                                }}
                            >
                                <Box onClick={() => page > 1 && setPage(page - 1)}
                                    sx={{
                                        cursor: page === 1 ? 'not-allowed' : 'pointer',
                                        opacity: page === 1 ? 0.4 : 1,
                                    }}
                                >
                                    <KeyboardArrowLeftIcon sx={{ color: 'grey' }} />
                                </Box>

                                {page > 5 && (
                                    <>
                                        <PageItem p={1} page={page} setPage={setPage} theme_color={theme_color} />
                                        <Typography sx={{ mx: 1 }}>...</Typography>
                                    </>
                                )}

                                {Array.from({ length: totalPages }, (_, i) => i + 1)
                                    .slice(Math.max(0, page - 2), Math.min(totalPages, page + 1))
                                    .map((p) => (
                                        <PageItem
                                            key={p}
                                            p={p}
                                            page={page}
                                            setPage={setPage}
                                            theme_color={theme_color}
                                        />
                                    ))}

                                {page < totalPages - 5 && (
                                    <>
                                        <Typography sx={{ mx: 1 }}>...</Typography>
                                        <PageItem
                                            p={totalPages}
                                            page={page}
                                            setPage={setPage}
                                            theme_color={theme_color}
                                        />
                                    </>
                                )}

                                <Box
                                    onClick={() => page < totalPages && setPage(page + 1)}
                                    sx={{
                                        cursor: page === totalPages ? 'not-allowed' : 'pointer',
                                        opacity: page === totalPages ? 0.4 : 1,
                                    }}
                                >
                                    <ChevronRightIcon sx={{ color: 'grey' }} />
                                </Box>
                            </Grid>
                        )}
                    </Grid>

                </Grid>
            </Grid>
        </>
    )
}

export default Blogs